import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58fa8a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "text-h5"
}
const _hoisted_2 = {
  key: 2,
  class: "text-h5"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "vs", -1))
const _hoisted_4 = { class: "text-wrap" }
const _hoisted_5 = { class: "text-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "General enemigo matado", -1))
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "General enemigo matado", -1))
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "partida-en-juego" }

import { ref, onMounted, computed, watch, reactive } from "vue";
import {
  ActualizarPairingEquiposDTO,
  PartidaTorneoDTO,
} from "@/interfaces/Partidas";
import { useRouter } from "vue-router";
import { formatFechaSpa } from "@/utils/Fecha";
import { ListaTorneoRequestDTO } from "@/interfaces/Lista";
import { getlistaTorneo } from "@/services/ListasService";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalValidarPartida from "@/components/ResultadosTorneos/ModalValidarPartida.vue";
import {
  updatePairingTorneo,
  updatePartidaTorneo,
} from "@/services/PartidaTorneoService";
import {
  RequestUpdatePairingTorneoDTO,
  UpdatePartidaTorneoDTO,
} from "@/interfaces/Live";
import ModalEditarPartida from "@/components/ResultadosTorneos/ModalEditarPartida.vue";
import { ListaDTO } from "@/interfaces/Usuario";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import ModalCambiarPairingEquipo from "./ModalCambiarPairingEquipo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardPartidaTorneoEquipoLive',
  props: {
    match: {},
    idUsuario: {},
    mesa: {},
    completa: { type: Boolean },
    editarPartidaPJ: { type: Boolean },
    soloValidarPJ: { type: Boolean },
    idEquipo: {},
    misPartidas: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const localMatch = reactive({ ...props.match });

const isLoading = ref(true);
const error = ref<string | null>(null);
const router = useRouter();
const listaData = ref<string>("");
const listaDTO = ref<ListaDTO>();
const nickJugador = ref<string>("");
const isModalListaVisible = ref<boolean>(false);
const currentEjercito = ref<string>();
const fechaPartidaFormateada = ref<string>("");
const showErrorModal = ref<boolean>(false);
const showErrorCambiarPairingModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);

//Variables para el modal validar partida
const isModalValidarVisible = ref<boolean>(false);
const idPartidaSeleccionada = ref<number>();
const usuarioSeleccionado = ref<1 | 2>();

//Variables para el modal de editar partida para validar (ModalEditarPartida)
const isModalEditarPartidaVisible = ref<boolean>(false);
const idUsuarioSelected = ref<number>(0);
const partidaSelected = ref<PartidaTorneoDTO>({
  ejercitoUsuario1: null,
  ejercitoUsuario2: null,
  escenarioPartida: null,
  fechaPartida: "",
  ganadorPartidaTorneo: null,
  idPartidaTorneo: 0,
  idTorneo: 0,
  idUsuario1: 0,
  idUsuario2: 0,
  liderMuertoUsuario1: null,
  liderMuertoUsuario2: null,
  nick1: "",
  nick2: "",
  numeroRonda: 0,
  partidaValidadaUsuario1: null,
  partidaValidadaUsuario2: null,
  resultadoUsuario1: null,
  resultadoUsuario2: null,
  idEquipo1: null,
  idEquipo2: null,
  nombreEquipo1: null,
  nombreEquipo2: null,
  idCapitan1: null,
  idCapitan2: null,
});

//Variables para cambiar pairing entre equipos
const showModalCambiarPairing = ref<boolean>(false);
const idEquipo1 = ref<number | null>(localMatch.idEquipo1);
const idEquipo2 = ref<number | null>(localMatch.idEquipo2);
const nombreEquipo1 = ref<string | null>(localMatch.nombreEquipo1);
const nombreEquipo2 = ref<string | null>(localMatch.nombreEquipo2);

const partidaCompleta = ref<boolean>(props.completa);
watch(
  () => props.completa,
  (nuevoValor) => {
    partidaCompleta.value = nuevoValor;
  }
);

const cambiarPairing = () => {
  showModalCambiarPairing.value = true;
};

const actualizarPairing = async (payload: ActualizarPairingEquiposDTO) => {
  // enviar al backend
  const isUpdate: boolean = await sendUpdateBack(
    payload.idJugador1,
    payload.idJugador2
  );

  if (isUpdate) {
    // Actualizas localMatch según el nuevo pairing
    localMatch.idUsuario1 = payload.idJugador1;
    localMatch.idUsuario2 = payload.idJugador2;
    localMatch.ejercitoUsuario1 = payload.ejercitoEquipo1;
    localMatch.ejercitoUsuario2 = payload.ejercitoEquipo2;
    localMatch.nick1 = payload.nick1;
    localMatch.nick2 = payload.nick2;

    // Si necesitas actualizar también nombres o algo más, hazlo aquí
  } else {
    // manejar error
  }
  showModalCambiarPairing.value = false;
};

const sendUpdateBack = async (idJugador1: number, idJugador2: number) => {
  try {
    isLoading.value = true;

    const body: RequestUpdatePairingTorneoDTO = {
      idPartidaTorneo: localMatch.idPartidaTorneo,
      idUsuario1: idJugador1,
      idUsuario2: idJugador2,
    };

    await updatePairingTorneo(body);
    return true;
  } catch (error) {
    console.error(error);
    showErrorCambiarPairingModal.value = true;
    return false;
  } finally {
    isLoading.value = false;
  }
};

const esCapitan = computed(() => {
  return (
    localMatch.idCapitan1 === props.idUsuario ||
    localMatch.idCapitan2 === props.idUsuario
  );
});

const initializeComponent = async () => {
  try {
    isLoading.value = true;
    fechaPartidaFormateada.value = await formatFechaSpa(
      localMatch.fechaPartida
    );
  } catch (err) {
    console.error(error);
    error.value = (err as Error).message;
    router.push({ name: "error" });
  } finally {
    isLoading.value = false;
  }
};

const verLista = async (idUsuario: number, idTorneo: number, nick: string) => {
  isLoading.value = true;
  if (idTorneo && idUsuario && nick) {
    const body: ListaTorneoRequestDTO = {
      idTorneo: idTorneo,
      idUsuario: idUsuario,
    };

    try {
      const listaResponse = await getlistaTorneo(body);
      listaDTO.value = listaResponse.data;
      if (listaDTO.value != undefined)
        listaData.value = listaDTO.value.listaData ?? "";
      nickJugador.value = nick;
      currentEjercito.value = listaDTO.value?.ejercito;
      isModalListaVisible.value = true;
    } catch (error) {
      console.error(error);
      isModalListaVisible.value = false;
      isLoading.value = false;
    } finally {
      isLoading.value = false;
    }
  }
};

const getGanador = (partida: PartidaTorneoDTO) => {
  if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
    return partida.nick1;
  } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
    return partida.nick2;
  } else {
    return "Empate";
  }
};

const getColorGanador = (partida: PartidaTorneoDTO, idUsuario: number) => {
  if (partida.ganadorPartidaTorneo === idUsuario) {
    return "green";
  } else if (partida.ganadorPartidaTorneo != null) {
    return "red";
  } else {
    return "orange";
  }
};

const abrirModalValidar = (match: PartidaTorneoDTO) => {
  idPartidaSeleccionada.value = match.idPartidaTorneo;
  isModalValidarVisible.value = true;
  props.idUsuario === match.idUsuario1
    ? (usuarioSeleccionado.value = 1)
    : (usuarioSeleccionado.value = 2);
};

const confirmarValidar = async () => {
  if (idPartidaSeleccionada.value) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: idPartidaSeleccionada.value,
    };

    if (usuarioSeleccionado.value == 1) body.partidaValidadaUsuario1 = true;
    else body.partidaValidadaUsuario2 = true;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error("confirmarValidar", error);
    } finally {
      isModalValidarVisible.value = false;
      window.location.reload();
    }
  }
};

const cerrarModalValidar = () => {
  isModalValidarVisible.value = false;
};

//Metodo que recoje el click del botón Validar Resultado y prepara los datos para enviar al backend
const editPartida = (partida: PartidaTorneoDTO, idUsuario: number) => {
  partidaSelected.value = partida;

  if (idUsuario == partida.idCapitan1) idUsuarioSelected.value = 1;
  else idUsuarioSelected.value = 2;

  isModalEditarPartidaVisible.value = true;
};

const confirmarEditarPartida = async (partida: PartidaTorneoDTO) => {
  isLoading.value = true;
  if (partida) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: partida.idPartidaTorneo,
      resultadoUsuario1: partida.resultadoUsuario1,
      resultadoUsuario2: partida.resultadoUsuario2,
      escenarioPartida: partida.escenarioPartida,
      liderMuertoUsuario1: partida.liderMuertoUsuario1,
      liderMuertoUsuario2: partida.liderMuertoUsuario2,
      partidaValidadaUsuario1: partida.partidaValidadaUsuario1,
      partidaValidadaUsuario2: partida.partidaValidadaUsuario2,
    };

    try {
      const response = await updatePartidaTorneo(body);

      if (response.data) {
        showSuccessModal.value = true;
        partidaCompleta.value = true;
      }
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
    } finally {
      isModalEditarPartidaVisible.value = false;
      isLoading.value = false;
    }
  }
};

const cerrarModalEditarPartida = () => {
  isModalEditarPartidaVisible.value = false;
};

const verProfileUser = (idUser: number) => {
  if (navigator.vibrate) {
    navigator.vibrate(500);
    router.push({ name: "detalle-jugador", params: { idUsuario: idUser } });
  } else {
    console.warn("La vibración no es compatible en este navegador.");
  }
};

onMounted(initializeComponent);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_hover, null, {
      default: _withCtx(({ props }) => [
        _createVNode(_component_v_card, _mergeProps(props, { class: "match-card mt-3" }), {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, {
              class: "text-center text-h5 text-wrap",
              style: {"position":"relative","font-family":"'Roboto', sans-serif","color":"#ffcc00","text-align":"center"}
            }, {
              default: _withCtx(() => [
                (localMatch.idCapitan1 === _ctx.idUsuario && !partidaCompleta.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      size: "small",
                      color: "primary",
                      variant: "tonal",
                      style: {"position":"absolute","left":"0","top":"50%","transform":"translateY(-50%)","margin-left":"8px"},
                      onClick: cambiarPairing
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cambiar ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.misPartidas)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Partida"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.mesa), 1)),
                (localMatch.idCapitan2 === _ctx.idUsuario && !partidaCompleta.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 3,
                      size: "small",
                      color: "primary",
                      variant: "tonal",
                      style: {"position":"absolute","right":"0","top":"50%","transform":"translateY(-50%)","margin-right":"8px"},
                      onClick: cambiarPairing
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cambiar ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_title, { class: "text-wrap match-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "5",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (verProfileUser(localMatch.idUsuario1)), ["prevent"])),
                      class: "player text-left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-wrap", { highlight: localMatch.idEquipo1 === _ctx.idEquipo }])
                        }, _toDisplayString(localMatch.nombreEquipo1), 3),
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-wrap", { highlight: localMatch.idEquipo1 === _ctx.idEquipo }])
                        }, " (" + _toDisplayString(localMatch.nick1) + ")", 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "score text-center marcador"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("p", null, _toDisplayString(localMatch.resultadoUsuario1) + "-" + _toDisplayString(localMatch.resultadoUsuario2), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "5",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (verProfileUser(localMatch.idUsuario2)), ["prevent"])),
                      class: "player text-right"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-wrap", { highlight: localMatch.idEquipo2 === _ctx.idEquipo }])
                        }, _toDisplayString(localMatch.nombreEquipo2), 3),
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-wrap", { highlight: localMatch.idEquipo2 === _ctx.idEquipo }])
                        }, " (" + _toDisplayString(localMatch.nick2) + ")", 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "match-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center",
                  class: "army-buttons"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            block: "",
                            class: "army-btn",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (
                  verLista(
                    localMatch.idUsuario1,
                    localMatch.idTorneo,
                    localMatch.nick1
                  )
                )),
                            style: {"font-size":"10px"},
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(localMatch.ejercitoUsuario1 ?? "Lista"), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-right"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            block: "",
                            class: "army-btn",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                  verLista(
                    localMatch.idUsuario2,
                    localMatch.idTorneo,
                    localMatch.nick2
                  )
                )),
                            style: {"font-size":"10px"},
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_5, _toDisplayString(localMatch.ejercitoUsuario2 ?? "Lista"), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-3 match-scenario" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          class: "location-icon"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-map-marker")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Escenario: "),
                        _createElementVNode("strong", null, _toDisplayString(localMatch.escenarioPartida || "No disponible"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("p", _hoisted_7, [
                              (localMatch.liderMuertoUsuario1 === true)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-check-circle")
                                    ]),
                                    _: 1
                                  }))
                                : (localMatch.liderMuertoUsuario1 === false)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-close-circle")
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-dots-horizontal")
                                      ]),
                                      _: 1
                                    }))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createElementVNode("p", _hoisted_9, [
                              (localMatch.liderMuertoUsuario2 === true)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-check-circle")
                                    ]),
                                    _: 1
                                  }))
                                : (localMatch.liderMuertoUsuario2 === false)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-close-circle")
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-dots-horizontal")
                                      ]),
                                      _: 1
                                    }))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.completa)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      align: "center",
                      class: "match-outcome"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              color: getColorGanador(localMatch, localMatch.idUsuario1),
                              class: "outcome-chip"
                            }, {
                              default: _withCtx(() => [
                                (localMatch.nick1 === getGanador(localMatch))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Victoria"))
                                  : (localMatch.nick2 === getGanador(localMatch))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Derrota "))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_12, "Empate"))
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "text-center"
                        }),
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              color: getColorGanador(localMatch, localMatch.idUsuario2),
                              class: "outcome-chip"
                            }, {
                              default: _withCtx(() => [
                                (localMatch.nick2 === getGanador(localMatch))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Victoria"))
                                  : (localMatch.nick1 === getGanador(localMatch))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Derrota "))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_15, "Empate"))
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_16, [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-sword-cross")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" Partida en juego...")
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })),
                (!partidaCompleta.value && _ctx.editarPartidaPJ && esCapitan.value)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              color: "success",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (editPartida(localMatch, _ctx.idUsuario)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Validar Resultadoo ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (!partidaCompleta.value && _ctx.soloValidarPJ && esCapitan.value)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "success",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (abrirModalValidar(localMatch)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Validar Resultado ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_row, { key: 4 }))
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, { class: "my-3" }),
    (isModalListaVisible.value)
      ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
          key: 0,
          listaData: listaData.value,
          nickJugador: nickJugador.value,
          ejercito: currentEjercito.value,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (isModalListaVisible.value = false))
        }, null, 8, ["listaData", "nickJugador", "ejercito"]))
      : _createCommentVNode("", true),
    (isModalEditarPartidaVisible.value)
      ? (_openBlock(), _createBlock(ModalEditarPartida, {
          key: 1,
          isVisible: isModalEditarPartidaVisible.value,
          partida: partidaSelected.value,
          idUsuario: idUsuarioSelected.value,
          onConfirmar: confirmarEditarPartida,
          onCerrar: cerrarModalEditarPartida
        }, null, 8, ["isVisible", "partida", "idUsuario"]))
      : _createCommentVNode("", true),
    (isModalValidarVisible.value)
      ? (_openBlock(), _createBlock(ModalValidarPartida, {
          key: 2,
          isVisible: isModalValidarVisible.value,
          idPartidaTorneo: idPartidaSeleccionada.value,
          onConfirmar: confirmarValidar,
          onCerrar: cerrarModalValidar
        }, null, 8, ["isVisible", "idPartidaTorneo"]))
      : _createCommentVNode("", true),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Partida validada con éxito.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "Ha ocurrido un error al validar la partida. Inténtalo de nuevo o contacta al administrador del torneo.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorCambiarPairingModal.value,
      message: "Ha ocurrido un error al cambiar el emparejamiento. Inténtalo de nuevo o contacta al administrador del torneo.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showErrorCambiarPairingModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalCambiarPairingEquipo, {
      isVisible: showModalCambiarPairing.value,
      idEquipo1: idEquipo1.value!,
      idEquipo2: idEquipo2.value!,
      nombreEquipo1: nombreEquipo1.value!,
      nombreEquipo2: nombreEquipo2.value!,
      onActualizar: actualizarPairing,
      onCerrar: _cache[10] || (_cache[10] = ($event: any) => (showModalCambiarPairing.value = false))
    }, null, 8, ["isVisible", "idEquipo1", "idEquipo2", "nombreEquipo1", "nombreEquipo2"]),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isLoading).value = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: "d-flex justify-center align-center",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "blue-lighten-3",
                  size: 57
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})